import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  wmBin: [
    // BinAttr1:
    // "BNTYP0001",
    // Name1: "BIN 001",
    // OpenBin: null,
    // UId: "100001",
  ]
}

const SliceBin = createSlice({
  name: "SliceBin",
  initialState: { value: initialState },

  reducers: {
    Bin_Set: (state, action) => {
      state.value = action.payload;
    },
    Bin_Init: (state) => {
      state.value = initialState;
    },
    Bin_WMBin: (state, action) => {
      state.value.wmBin = action.payload.wmBin;
    },
    // Bin_SetValue: (state, action) => {
    //   state.value = action.payload;
    // },
  },
});

export const {
  Bin_Set,
  Bin_Init,
  Bin_WMBin,
} = SliceBin.actions;
export default SliceBin.reducer;
